<template>
    <div class="body">
        <p  class="font1" style="padding-top: 8vh;">孜孜不倦，博览群书</p>


        <p  class="font2" style="padding-top: 5vh;">推荐书籍如下：</p>

        <div class="wrapper">
            <div class="bookTextOne">
                <h3>《赋能》</h3>
                <div id="qiymet2" @click="openPDF(1)">
                    <p>
                        <i class="fa fa-eye fa-2x"></i>
                    </p>
                </div>
                <p style="padding-bottom: 4px;width: 100%;">作者:斯坦利•麦克里斯特尔</p>
               
            </div>
            <div class="bookTextTwo">
                <h3>《组织文化诊断与变革》</h3>
                <div id="qiymet1" @click="openPDF(2)">
                    <p>
                        <i class="fa fa-eye fa-2x"></i>
                    </p>
                </div>
                <p style="padding-bottom: 4px;width: 100%;">作者：金·卡梅隆 、 罗伯特·奎因</p>  
            </div>
        </div>
        <!-- <div class="dialog" v-show="bookShow">        
            <i style="margin-left:95%;color: #090808;" @click="bookShow = false" class="fa fa-close fa-1x"></i>
            <div v-if="this.bookPage==1" style="text-align: justify;width: 100%;">
              <div style="width: 90%;margin: 0 auto;">
                  框架思维是一本探讨如何通过构建和应用思维框架来提升问题解决能力和决策质量的书籍。<br><br>  
				  在这个信息爆炸的时代，掌握框架思维，意味着能够更有效地筛选信息，深入分析问题的本质。本书不仅解释了框架思维的理论基础，还提供了丰富的实用工具和方法，帮助读者在实际工作和生活中应用这种思维模式。从实践挑战到思维习惯的培养，作者以清晰的逻辑和生动的案例，引导我们如何一步步搭建自己的认知框架，有效应对未来的挑战和机遇。<br><br>  
				  无论你是领导者、企业家还是个人发展者，这本书都将是你理解和应用框架思维的宝贵资源。<br><br>  
                  <p style="font-size: 15px; color: chocolate;">*详情请登录富学宝典上搜索“框架思维”查看！</p>
              </div>
            </div>
            <div v-if="this.bookPage==2" style="text-align: justify;">
				<div style="width: 90%;margin: 0 auto;">
					本书深入浅出地探讨了战略思维不仅是高管的专利，而是每个人都可以掌握的关键技能。<br><br>
					作者强调，战略思维的核心在于一种面向解决问题的心态，而非仅仅依赖经验或视野的广阔。<br><br>
					书中提供了一系列实用的战略思考模式和工具，帮助读者在面对战略问题时减少不确定性，即使在数据不足的情况下也能制定出可靠的策略。<br><br>
					无论你是企业高管、普通员工还是自由职业者，这本书都将为你的职业生涯和个人发展提供极大的帮助，让你的战略思维能力得到显著提升，并在实际应用中越来越熟练。<br><br>
					<p style="font-size: 15px; color: chocolate;">*详情请登录富学宝典上搜索“战略思维”查看！</p>
				</div>
            </div>
        </div> -->
    </div>
</template>
  
<script>
export default {
	props: {
		ReportData: {
		type: Object,
		default: {}
		}
	},
	data() {
		return {
            widthWindow: window.innerWidth, 
            widthBlock: window.innerWidth*0.47,
            heightBlock: window.innerHeight*0.257,
            bookPage: 1,
            bookId: 0,
            // bookShow: false,
		}
	},
	methods: {
		openPDF(bookPage) {
			if(bookPage === 1){
				// this.bookPage = 1
				// this.bookId = 1
                window.location.href = 'https://iedu.foxconn.com/public/play/playCourse?courseId=50815';
			} else {
				// this.bookPage = 2
				// this.bookId = 2
                window.location.href = 'https://iedu.foxconn.com/public/play/playCourse?courseId=37220';
			}
			// this.bookShow = true
		},
	}
}
</script>
  
  <style scoped>
  .body {
      background: url("../../assets/logo.jpg") 15px calc(100% - 20px) no-repeat,
                  url("../../assets/logo1.png") right  top  no-repeat,
                  url("../../assets/24November/bg.jpg")  no-repeat;
      background-size: 17% 8%,110px 35px,cover;
      width: 100%;
      height: 100vh;
      display: flex;
      flex-direction: column;  
      align-items: center;  
  }
  .font1 {
      width: 80%;
      margin: 0;
      /* text-align: center; */
      font-size: 20px;
      color: #46429e;
      font-weight: bold;
      font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .font2 { 
      width: 80%;
      margin: 0 auto;
      padding: 0;
      color: #000;
      font-size: 20px;
      font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .font3 {
      font-size: 20px;
      font-weight: bold;
      color: #36854f;
      text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
      font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .dialog {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      z-index: 2000;
      /* bottom: 20%; */
      width: 91%;
      height: auto;
      background: #fff;
      border-radius: 7px;
      padding: 7px;
      box-shadow: #eae62ebd 1px;
  }

  .fa {
      color: #fff8e8;
  }


  .wrapper {
      z-index: 1000;
      width: 97%;
      /* height: auto; */
      height: 40vh;
      display: flex;
      justify-content: center;
      background-color: rgba(255, 255, 255, 0.5);
      border-radius: 10px;;
      border-radius: 17px;
      margin: 0 auto;
      flex-wrap: wrap;
  }

  .bookOne {
      width: 30%;
      height: 20%;
      /* margin-top: 10px; */
  }

  .bookTwo {
      width: 30%;
      height: 20%;
  }

  .bookTextOne {
      margin-left: 11px;
      width: 90%;
      height: 90px;
      color: #000;
  }
  .bookTextTwo {
      margin-left: 11px;
      width: 90%;
      height: 130px;
      color: #000;
    }

    #qiymet2 {
      float: right;
      margin-right: 20px;
      margin-top: -35px;
      padding: 0px 17px 0px 17px;
      border-radius: 20px;
      color: #000;
      font-family: 'Source Code Pro', cursive;
      background-color: rgb(39, 178, 217);
  }

  #qiymet1 {
      float: right;
      margin-right: 20px;
      margin-top: -35px;
      padding: 0px 17px 0px 17px;
      /* width: 51px;
      height: 51px; */
      border-radius: 20px;
      color: #000;
      font-family: 'Source Code Pro', cursive;
      background-color: rgb(39, 178, 217);
      z-index: 1000;
  }

  .zezhao {
      width: 100%;
      height: 100%;
      background: #000000bc;
      z-index: 1920;
      position: absolute;
  }

  button {
      border: none;
      outline: none;
      background-color: rgb(39, 178, 217);
      padding: 10px 20px;
      font-size: 12px;
      font-weight: 700;
      color: #fff;
      border-radius: 5px;
      transition: all ease 0.1s;
      box-shadow: 0px 5px 0px 0px rgb(116, 219, 247);
      margin: 5px;
  }

  button:active {
      transform: translateY(5px);
      box-shadow: 0px 0px 0px 0px rgb(116, 219, 247);
  }

  .donghua{
      animation:flash 3s infinite
    }
    @keyframes flash {
      0% {
        opacity: 0;
      }
      80% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
  }
  </style>